export default "__VITE_ASSET__l5vJ$tl8__"